/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from '@environment';
import { CurrentUserService } from 'src/app/services/current-user/current-user.service';
import { ProductsService } from 'src/app/services/products/products.service';
import { RefreshService } from 'src/app/services/refresh/refresh.service';

@Component({
  selector: 'wsn-sidenav-wrapper',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {
  /** Navigation Menu Items for app. This is an array of Category. Each category has menu items. */
  TREE_DATA = [
    {
      name: environment.appName,
      items: [
        {
          id: 1,
          name: 'My Products',
          route: '/products',
          children: []
        },
        {
          id: 2,
          name: 'Installation Guide',
          route: '/installation-guide',
          children: []
        },
        // --- File sharing is not required (or implemented) at this time. ---
        // {
        //   id: 3,
        //   name: 'File Sharing',
        //   route: '/files',
        //   children: []
        // },
        {
          id: 4,
          name: 'Access Documentation',
          route: '/documentation',
          children: []
        },
        {
          id: 5,
          name: 'Open Support Case',
          route: '/support',
          children: []
        },
        {
          id: 6,
          name: 'Manage Licenses',
          route: '/licenses',
          children: []
        },
        {
          id: 7,
          name: 'Legal Notices',
          route: '/legal',
          children: []
        },
        {
          id: 8,
          name: 'Help/FAQ',
          route: '/help',
          children: []
          // todo: enable feedback function
          // },
          // {
          //   id: 9,
          //   name: 'Feedback',
          //   route: '/feedback',
          //   children: []
        }
      ]
    }
  ];

  selectedNode = {
    id: 1,
    name: 'My Products',
    route: '/products'
  };

  constructor(
    private router: Router,
    private currentUserService: CurrentUserService,
    private refreshService: RefreshService,
    private productsService: ProductsService
  ) {}

  ngOnInit(): void {
    // Sidenav displays upon login, so this is the right time to refresh things:
    this.refreshService
      .RefreshEverything(this.currentUserService.getUsername())
      .subscribe(() => console.log('entitlements and tozny refreshed'));

    this.initSelectedNode(this.router.url);

    if (this.currentUserService.hasAdminRole()) {
      this.TREE_DATA.forEach((item) => {
        if (item.name === 'User Settings') {
          item.items.push({
            id: 11,
            name: 'License',
            route: '/settings/license',
            children: []
          });
        }
      });
    }

    // We listen to router url changes because routes can change form outside
    // of this component.
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.initSelectedNode(event.urlAfterRedirects);
      }
    });

    this.productsService.getUserProducts(this.currentUserService.getUsername()).subscribe((result) => {
      console.log(result);
    });
  }

  /**
   * Loops over sidenav navigation tree data to find which route matches
   * an item in a category.
   *
   * @param currentRoute current loaded route. Eg. /dashboard.
   */
  initSelectedNode(currentRoute: string): void {
    this.TREE_DATA.forEach((category) => {
      category.items.forEach((item) => {
        if (item.route === currentRoute) {
          this.selectedNode = item;
        }
      });
    });
  }

  /**
   * Navigates to given route.
   *
   * @param route route string. Eg. /dashboard.
   */
  handleUpdateNavigation(route: string): void {
    if (route === '/products') {
      localStorage.setItem('gallery_visited', '1');
    }
    this.router.navigate([route]);
  }
}
